import { LoyaltyAcmService } from './../../../services/loyalty/loyalty-acm.service';
import { Observable } from 'rxjs';
import { LoyaltyCardService } from './../../../services/loyalty/loyalty-card.service';
import { Report } from 'app/models/report.model';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyPointTransferService } from '../../../services/loyalty/loyalty-point-transfers.service';
import { DatePipe } from '@angular/common';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import {Component,OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import { Router } from '@angular/router';

//this is for Stimulsoft
declare var Stimulsoft: any;
declare var System: any;

@Component({
  selector: 'kv-loyalty-point-transfer',
  templateUrl: './loyalty-point-transfer.component.html',
  styleUrls: ['./loyalty-point-transfer.component.css']
  }
)
export class LoyaltyPointTransferComponent implements OnInit{

  public serverPagination = KontableComponent.ServerPagination;
  public newDataAvailable = false;

  sourceCard: any;
  destinationCard: any;

  viewer: any;
  pdfReport: Report;  

  show = {
    datatable: false,
    report: false
  }
  fields: any = {}

  constructor(
    public srvPointTransfer: LoyaltyPointTransferService,    
    private translate: TranslateService,
    private srvCard: LoyaltyCardService,
    private srvAccumulator: LoyaltyAcmService,
    private router: Router    
  ) {

  }
  ngOnInit(){

    this.translate.get([
      'customers.accumulator',       
      'loyalty.point_transfer',            
      'pointTransfer.cardDestination',
      'pointTransfer.cardSource', 
      'pointTransfer.customerHostSrc',
      'pointTransfer.customerHostDestination',
      'pointTransfer.value',           
      'loyalty.points',      
      'loyalty.point_transfer_destination',
      'loyalty.point_transfer_source',       
      'common.store_title',
      'customerInfoSheet.date',
      'customerDetail.flag_signature',
      'reportTransferPoint.header_store',
      'reportTransferPoint.header_customer',
      'reportTransferPoint.name_and_surname',
      'reportTransferPoint.source_card',
      'reportTransferPoint.destination_card',
      'reportTransferPoint.points_transferred',
      'reportTransferPoint.balance_before',
      'reportTransferPoint.balance_after',
      'reportTransferPoint.transferDate',
      'reportTransferPoint.causalePlus',
      'reportTransferPoint.causaleMinus'
    ]).subscribe(translations => {
      



      //todo inserire i due campi nelle traduzioni corrette
      //la datanon sembra comprendere l'orario
      this.fields = {              
        accumulator: translations['customers.accumulator'],                
        point_transfer: translations['loyalty.point_transfer'],        
        cardSource: translations['pointTransfer.cardSource'],
        cardDestination: translations['pointTransfer.cardDestination'],
        customerHostSrc: translations['pointTransfer.customerHostSrc'],
        customerHostDest: translations['pointTransfer.customerHostDestination'],
        value: translations['pointTransfer.value'],
        source_card: translations['reportTransferPoint.source_card'],
        destination_card: translations['reportTransferPoint.destination_card'],
        points: translations['loyalty.points'],                
        point_transfer_source: translations['loyalty.point_transfer_source'],
        point_transfer_destination: translations['loyalty.point_transfer_destination'],                
        store_title: translations['common.store_title'],
        date: translations['customerInfoSheet.date'],
        flag_signature: translations['customerDetail.flag_signature'],
        header_customer: translations['reportTransferPoint.header_customer'],
        header_store: translations['reportTransferPoint.header_store'],
        name_and_surname: translations['reportTransferPoint.name_and_surname'],
        points_transferred: translations['reportTransferPoint.points_transferred'],
        balance_before: translations['reportTransferPoint.balance_before'],
        balance_after: translations['reportTransferPoint.balance_after'],
        transferDate:translations['reportTransferPoint.transferDate'],
        causalePlus:translations['reportTransferPoint.causalePlus'],
        causaleMinus:translations['reportTransferPoint.causaleMinus']
      };      
      
      this.show.datatable = true;
    })
    
  }
  remove(event){
    this.newDataAvailable = true;
  }
  onClickAdd(){
    this.router.navigate(['/loyalty/point_transfer/form']);
  }
  /*** view report from Report model ***/
  onClickReport(row){   
    
    let sourceCardParams = [{key: "card_no", value: row.card_no_src}];
    let destinationCardParams = [{key: "card_no", value: row.card_no_dest}];    
    let acmParams = [{key: "acm_code", value: row.acmCode},{key: "channel_id", value: row.acmChannelId}];
    
    let SourceCard = this.srvCard.list(null, null, sourceCardParams);
    let Accumulator = this.srvAccumulator.getAcmFromParams(acmParams);
    let DestinationCard = this.srvCard.list(null, null, destinationCardParams);
    
    Observable.zip(
      SourceCard,
      DestinationCard,
      Accumulator
    ).subscribe(([          
      resSourceCard,
      resDestinationCard,
      resAcm
    ]) => {
         
// Change report viewer options      
var options = new Stimulsoft.Viewer.StiViewerOptions();
//options.appearance.openLinksWindow = "_blank";
options.appearance.scrollbarsMode = true;
options.appearance.fullScreenMode = true;    


this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);        
var stiReport = new Stimulsoft.Report.StiReport();

stiReport.loadFile("./assets/report/PointTransferReport.mrt");        

/* impostazioni delle variabili dal codice verso il modello .mrt */
stiReport.dictionary.variables.getByName("var_source_title").valueObject = this.fields.point_transfer_source;
stiReport.dictionary.variables.getByName("var_destination_title").valueObject = this.fields.point_transfer_destination;
stiReport.dictionary.variables.getByName("var_customer_title").valueObject = this.fields.name_and_surname;
stiReport.dictionary.variables.getByName("var_store_title").valueObject = this.fields.store_title;        
stiReport.dictionary.variables.getByName("var_point_title").valueObject = this.fields.points;
stiReport.dictionary.variables.getByName("var_accumulator_title").valueObject = this.fields.accumulator;
stiReport.dictionary.variables.getByName("var_date_title").valueObject = this.fields.date;
stiReport.dictionary.variables.getByName("var_signature_title").valueObject = this.fields.flag_signature;
stiReport.dictionary.variables.getByName("var_headerStore_title").valueObject = this.fields.header_store;
stiReport.dictionary.variables.getByName("var_headerCustomer_title").valueObject = this.fields.header_customer;
stiReport.dictionary.variables.getByName("var_bal_bef_title").valueObject = this.fields.balance_before;
stiReport.dictionary.variables.getByName("var_bal_aft_title").valueObject = this.fields.balance_after;
stiReport.dictionary.variables.getByName("var_source_data").valueObject = resSourceCard ? resSourceCard.data[0].card_no : "";
stiReport.dictionary.variables.getByName("var_destination_data").valueObject = resDestinationCard ? resDestinationCard.data[0].card_no : "";
stiReport.dictionary.variables.getByName("var_customer_src_data").valueObject = row.customerHostSrc || "";
stiReport.dictionary.variables.getByName("var_customer_dest_data").valueObject = row.customerHostDest || "";
stiReport.dictionary.variables.getByName("var_store_data").valueObject = resSourceCard ? resSourceCard.data[0].store : "";
stiReport.dictionary.variables.getByName("var_point_data").valueObject = row.value != null ? row.value.toString() : "---";
stiReport.dictionary.variables.getByName("var_accumulator_data").valueObject = (resAcm && resAcm.length == 1) ? (resAcm[0].acm_code + " - " + resAcm[0].description) : "";
stiReport.dictionary.variables.getByName("var_date_data").valueObject = ""//this.operationDate;
stiReport.dictionary.variables.getByName("var_src_bal_bef_data").valueObject = row.balance_before_src != null ? row.balance_before_src.toString() : "---";
stiReport.dictionary.variables.getByName("var_src_bal_aft_data").valueObject = row.balance_after_src != null ? row.balance_after_src.toString() : "---";
stiReport.dictionary.variables.getByName("var_dest_bal_bef_data").valueObject = row.balance_before_dest != null ? row.balance_before_dest.toString() : "---";
stiReport.dictionary.variables.getByName("var_dest_bal_aft_data").valueObject = row.balance_after_dest != null ? row.balance_after_dest.toString(): "---";

                                      
//Render report
stiReport.render();                
this.viewer.report = stiReport;     
this.show.report = true;        
var self = this;   

setTimeout(() => {
  self.viewer.renderHtml("pdfPointTransferContent");    
  self.addCloseButton();       
  $('body').css('overflow','none');
}, 100);


    });


    
}
 /*** close button on report viewer at the top right of page ***/
addCloseButton(){

var userButton = this.viewer.jsObject.SmallButton("userButton", "Close", "emptyImage"); 

var self = this;
userButton.action = function () {       
  self.pdfReport = null;                         
  self.show.report = false;
  $('body').css('overflow','auto');
}
  
var toolbarTable = this.viewer.jsObject.controls.toolbar.firstChild.firstChild;
var buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
var userButtonCell = buttonsTable.rows[0].insertCell(0);
userButtonCell.className = "stiJsViewerClearAllStyles";
userButtonCell.appendChild(userButton);
}



formatDate(dateString: string): string {
  if (!dateString) {
    return 'Invalid Date';
  }

  const date = new Date(dateString);

  // Controlla se la data è invalida
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  // Estrae i componenti della data
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString();
  const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString();
  const year = date.getFullYear();
  const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString();
  const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes().toString();

  // Combina il tutto nel formato desiderato
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}



}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-point-transfer/loyalty-point-transfer.component.ts